import type { SVGProps } from 'react';

export default function RedRock({
  width = 32,
  height = 32,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={32} height={32} rx={8} fill='#ff0000' />
      <g transform='translate(4.8 4.8) scale(0.04375)' fill='white'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 213L219 6.5L491.5 7L494 405.5L431 343.5L376 342.5L302 268.5L266 302.5L155 191.5L18 328.5L17.5 213ZM391.5 55.5A50.5 50.5 0 1 0 391.5 156.5A50.5 50.5 0 1 0 391.5 55.5Z'
        />
        <path d='M144.5 479L167.5 391L153 223.5L269 358.5L307 304.5L361 364.5L420 366.5L494.5 426L494 479.5L424 446.5L417.5 451L399 473.5L341 410.5L389 503.5L266 491.5L234 446.5L231.5 447L204 485.5L144.5 479Z' />
      </g>
    </svg>
  );
}
